module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }